export default "__VITE_ASSET__D8QCqvh2__"